import UserManualContainer from './UserManualContainer'

export default UserManualContainer
